import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import Skeleton from '../../components/animations/Skeleton';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProjectsShowcase from './components/ProjectsShowcase';
import SmartToolsPreview from './components/SmartToolsPreview';
import BlogSection from './components/BlogSection';
import TestimonialCarousel from './components/TestimonialCarousel';
import CTASection from './components/CTASection';
import Footer from '../../components/ui/Footer';
import QuoteModal from './components/QuoteModal';
import { useWebsiteData } from '../../context/WebsiteDataContext';

const Homepage = () => {
  const { getPublishedBlogs } = useWebsiteData();
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [quoteService, setQuoteService] = useState(null);
  const [loadingAll, setLoadingAll] = useState(true);

  React.useEffect(() => {
    // Simulate loading, replace with actual fetch logic
    const timer = setTimeout(() => setLoadingAll(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleGetQuote = (service) => {
    setQuoteService(service);
    setShowQuoteModal(true);
  };

  const handleQuoteModalClose = () => {
    setShowQuoteModal(false);
    setQuoteService(null);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        {loadingAll ? (
          <>
            {/* HeroSection Skeleton: Large banner */}
            <Skeleton variant="card" className="my-8 w-full h-64" />
            {/* ServicesSection Skeleton: 3 service cards */}
            <div className="flex gap-6 my-8">
              <Skeleton variant="card" className="w-1/3 h-40" />
              <Skeleton variant="card" className="w-1/3 h-40" />
              <Skeleton variant="card" className="w-1/3 h-40" />
            </div>
            {/* SmartToolsPreview Skeleton: horizontal tool cards */}
            <div className="flex gap-4 my-8">
              <Skeleton variant="card" className="w-1/4 h-32" />
              <Skeleton variant="card" className="w-1/4 h-32" />
              <Skeleton variant="card" className="w-1/4 h-32" />
              <Skeleton variant="card" className="w-1/4 h-32" />
            </div>
            {/* ProjectsShowcase Skeleton: 3 project cards */}
            <div className="flex gap-6 my-8">
              <Skeleton variant="card" className="w-1/3 h-56" />
              <Skeleton variant="card" className="w-1/3 h-56" />
              <Skeleton variant="card" className="w-1/3 h-56" />
            </div>
            {/* BlogSection Skeleton: 2 blog posts */}
            <div className="flex gap-6 my-8">
              <Skeleton variant="card" className="w-1/2 h-32" />
              <Skeleton variant="card" className="w-1/2 h-32" />
            </div>
            {/* TestimonialCarousel Skeleton: 2 testimonials */}
            <div className="flex gap-6 my-8">
              <Skeleton variant="card" className="w-1/2 h-24" />
              <Skeleton variant="card" className="w-1/2 h-24" />
            </div>
            {/* CTASection Skeleton: button */}
            <Skeleton variant="button" className="my-8 w-48 h-12" />
          </>
        ) : (
          <>
            <HeroSection />
            <ServicesSection onGetQuote={handleGetQuote} />
            <SmartToolsPreview />
            <ProjectsShowcase />
            <BlogSection />
            <TestimonialCarousel />
            <CTASection />
          </>
        )}
      </main>
      <Footer />
      {/* Quote Modal */}
      {showQuoteModal && quoteService && (
        <QuoteModal
          service={quoteService}
          isOpen={showQuoteModal}
          onClose={handleQuoteModalClose}
        />
      )}
    </div>
  );
};

export default Homepage;